module.exports = __webpack_public_path__ + "static/media/bubbles-top.aab2d9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biocodex-um/bubbles-top.png
// module id = 646
// module chunks = 1